import { FC } from 'react';
import { Typography } from 'antd';

import { Option } from 'models';

import { useTranslate } from 'hooks';

import { CheckBoxGroup, FormItem, SwitchButton, TextField } from 'componets/form';

import Utils from 'utils/utils';

import styles from './index.module.scss';

type FilterItemProps = {
	options?: Option[];
	name: string;
	title: string;
	isRange?: boolean;
	isField?: boolean;
	isCheckbox?: boolean;
	isSwitch?: boolean;
	checked?: boolean;
	onClick?: (v: boolean) => void;
	mark?: string;
};

export const FilterItem: FC<FilterItemProps> = ({
	options,
	name,
	title,
	isRange,
	isField,
	isSwitch,
	isCheckbox,
	checked = false,
	onClick,
	mark = '%',
}) => {
	const { fromText, toText } = useTranslate(['fromText', 'toText']);

	return (
		<div className={styles.filterItem}>
			{isSwitch && typeof onClick === 'function' ? (
				<FormItem name={name}>
					<SwitchButton label={title} loading={false} checked={checked} onClick={onClick} />
				</FormItem>
			) : (
				<>
					<Typography.Title level={5}>{title}</Typography.Title>

					{isField && (
						<FormItem
							name={name}
							className={styles.inputText}
							normalize={name === 'loanId' ? Utils.transformToFixedNumber : undefined}
						>
							<TextField label="" />
						</FormItem>
					)}

					{isRange && (
						<div className="primaryMarket__row">
							<div className={styles.inputWrapper}>
								<FormItem
									name={`${name}[from]`}
									normalize={Utils.transformToFixedNumber}
									className={styles.inputText}
								>
									<TextField label={fromText} />
								</FormItem>

								<span className={styles.percent}>{mark}</span>
							</div>

							<div className={styles.separator} />

							<div className={styles.inputWrapper}>
								<FormItem name={`${name}[to]`} normalize={Utils.transformToFixedNumber}>
									<TextField label={toText} />
								</FormItem>

								<span className={styles.percent}>{mark}</span>
							</div>
						</div>
					)}

					{isCheckbox && options && (
						<FormItem name={name}>
							<CheckBoxGroup options={options} />
						</FormItem>
					)}
				</>
			)}
		</div>
	);
};
